module.exports = __webpack_public_path__ + "static/media/i38.236fe673.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i38.svg
// module id = 356
// module chunks = 12